import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOutageNotificationStatusVm } from '../outage-notification-status-vm.model';
import { IOutageResolvedNotificationIm } from '../outage-resolved-notification-im.model';

@Injectable({ providedIn: 'root' })
export class OperatorOutageResolvedNotificationService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorOutageResolvedNotification`;
  }

  get(): Observable<IOutageNotificationStatusVm> {
    const headers = this.createHeaders();
    return this.http.get<IOutageNotificationStatusVm>(this.baseUrl, { headers });
  }

  post(outageResolvedNotificationIm: IOutageResolvedNotificationIm): Observable<IOutageNotificationStatusVm> {
    const headers = this.createHeaders();
    return this.http.post<IOutageNotificationStatusVm>(this.baseUrl, outageResolvedNotificationIm, { headers });
  }

  delete(): Observable<IOutageNotificationStatusVm> {
    const headers = this.createHeaders();
    return this.http.delete<IOutageNotificationStatusVm>(this.baseUrl, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
